export function registerForm() {
  return {
    form: { loginName: '', password: '' },
    errors: {}, notice: '', loading: false,

    validate() {
      this.errors = {};

      if (!this.form.loginName) {
        this.errors.loginName = 'Username or email is required.';
      }
      if (!this.form.password || this.form.password.length < 8) {
        this.errors.password = 'Use at least 8 characters.';
      }

      return Object.keys(this.errors).length === 0;
    },

    async submit() {
      this.notice = '';
      this.errors = {};
      if (!this.validate()) return;

      this.loading = true;

      // Build FormData from the actual form so Craft sees csrf/action/redirect/successMessage
      const fd = new FormData(this.$refs.form);
      // Overwrite with Alpine models to be safe
      fd.set('loginName', this.form.loginName);
      fd.set('password', this.form.password);

      try {
        const res = await fetch(this.$refs.form.action || window.location.pathname, {
          method: 'POST',
          body: fd,
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });

        // Craft controllers return JSON on AJAX; shape typically includes success, errors, message
        const data = await res.json();

        if (data.success) {
          // Prefer server message; fall back to our own
          this.notice = data.message || 'Thanks — please check your email.';
          this.errors = {};
          // If Craft returns a URL, you can honour it:
          if (data.returnUrl) window.location = data.returnUrl;
          // Otherwise keep the user here and show the success state.
        } else {
          // Map server errors to fields; include a form-level message if present.
          this.errors = data.errors || {};
          if (data.message && !this.errors._form) this.errors._form = data.message;
        }
      } catch (e) {
        this.errors._form = 'Network error. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
}

export function loginForm() {
  return {
    form: { loginName: '', password: '' },
    errors: {}, notice: '', loading: false,

    validate() {
      this.errors = {};

      if (!this.form.loginName) {
        this.errors.loginName = 'Username or email is required.';
      }
      if (!this.form.password) {
        this.errors.password = 'Password is required.';
      }
      return Object.keys(this.errors).length === 0;
    },

    async submit() {
      this.notice = '';
      this.errors = {};
      if (!this.validate()) return;

      this.loading = true;

      // For login, we need to submit the form normally to let Craft handle the redirect
      // But we can still validate client-side first
      try {
        // Submit the form normally - this will let Craft handle the redirect server-side
        this.$refs.form.submit();
      } catch (e) {
        this.errors._form = 'Network error. Please try again.';
        this.loading = false;
      }
    }
  }
}

export function forgotPasswordForm() {
  return {
    form: { loginName: '' },
    errors: {},
		notice: '',
		loading: false,

    validate() {
      this.errors = {};

      if (!this.form.loginName) {
        this.errors.loginName = 'Username or email is required.';
      }
      return Object.keys(this.errors).length === 0;
    },

    async submit() {
      this.notice = '';
      this.errors = {};
      if (!this.validate()) return;

      this.loading = true;

      try {
        this.$refs.form.submit();
      } catch (e) {
        this.errors._form = 'Network error. Please try again.';
        this.loading = false;
      }
    }
  }
}

export function setPasswordForm() {
  return {
    form: { newPassword: '' },
    errors: {},
		notice: '',
		loading: false,

    validate() {
      this.errors = {};

      if (!this.form.newPassword) {
        this.errors.newPassword = 'New password is required.';
      }
      return Object.keys(this.errors).length === 0;
    },

    async submit() {
      this.notice = '';
      this.errors = {};
      if (!this.validate()) return;

      this.loading = true;

      // For login, we need to submit the form normally to let Craft handle the redirect
      // But we can still validate client-side first
      try {
        // Submit the form normally - this will let Craft handle the redirect server-side
        this.$refs.form.submit();
      } catch (e) {
        this.errors._form = 'Network error. Please try again.';
        this.loading = false;
      }
    }
  }
}
